import { render, staticRenderFns } from "./frontend.vue?vue&type=template&id=697eef67"
import script from "./frontend.vue?vue&type=script&lang=js"
export * from "./frontend.vue?vue&type=script&lang=js"
import style0 from "./frontend.vue?vue&type=style&index=0&id=697eef67&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports